import React, { ComponentProps, useState } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import ModalDialog from '../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { BlockBar, BlockBarButton } from '../../_lib/components/BlockBar';
import { ModalDialogModifier } from '../../components/organisms/ModalDialog/ModalDialog.modifier';
import { Icons } from '../../components/atoms/SVG';
import {
  ContentSearchStatisticsDefaultView,
  ContentSearchStatisticsViewProps,
} from './views/ContentSearchStatisticsDefaultView';
import { DefaultView } from '../../types/BlockWithViews';

type ContentSearchStatisticsBlockProps = {
  views: DefaultView<ContentSearchStatisticsViewProps>;
};

function ContentSearchStatistics(props: ContentSearchStatisticsBlockProps) {
  const { t } = useSonTranslation('ContentSearchStatistics');
  const [openStatistics, setOpenStatistics] = useState<boolean>(false);

  return (
    <>
      <BlockBar heading={t('evaluation')} hierarchy={3}>
        <BlockBarButton onClick={() => setOpenStatistics(true)} svgSpriteId={Icons.ANALYSIS} text={t('title')} />
      </BlockBar>
      {openStatistics && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setOpenStatistics(false)}
          headline={t('title')}
        >
          <ContentSearchStatisticsDefaultView {...props.views.default} />
        </ModalDialog>
      )}
    </>
  );
}

export const ContentSearchStatisticsBlock = asBlock(ContentSearchStatistics, BlockType.contentsearchstatistics);
export type ContentSearchStatisticsBlock = ComponentProps<typeof ContentSearchStatisticsBlock>;
